<template>
  <div class="timeRange">
    <div class="calendar">
      <table>
        <thead>
          <tr>
            <th rowspan="6" class="weekRow"><b>周/时间</b></th>
            <th colspan="12"><b>00:00 - 12:00</b></th>
            <th colspan="12"><b>12:00 - 24:00</b></th>
          </tr>
          <tr>
            <td colspan="1" v-for="index in 24" :key="index">{{ index - 1 }}</td>
          </tr>
        </thead>
        <tbody @mousemove.prevent="handleMouseMove">
          <tr v-for="(item, index) in weekDate" :key="index">
            <td>{{ item }}</td>
            <td class="calendar-atom-time" v-for="i in 24" :key="index + '-' + i"
              :class="{ 'active': selectCells[`${index}_${i}`] }" @mousedown.prevent="handleMouseDown(index, i, $event)"
              @mouseup.prevent="handleMouseUp(index, i)">
            </td>
          </tr>
          <div id="box" v-show="moveStartEvent"></div>
        </tbody>
      </table>
      <div class="table-core">
        <div class="clearfix">
          <span class="pull-left tip-text">可拖动鼠标选择时间段</span>
          <button class="clearBtn" @click="handleClear">清除所有</button>
        </div>
        <ul>
          <li v-for="(item, index) in selectDate" :key="index" v-if="item.data && item.data.length">
            <label>{{ item.label }}</label>
            <span v-for="(o, idx) in item.data" :key="idx">{{ o[0] }}~{{ o[1] }}</span>
          </li>
        </ul>
      </div>
    </div>
    <el-button type="primary" @click="getsumtime">计算开始</el-button>
  </div>
</template>
  
<script>
export default {
  name: 'timeRange',
  data() {
    return {
      weekDate: ['星期一', '星期二', '星期三', '星期四', '星期五', '星期六', '星期日'],
      selectCells: {},
      selectDate: {},
      moveStartEvent: false,
      moveStartColumn: 0,
      moveStarRow: 0,
      moveStartX: 0,
      moveStartY: 0
    }
  },
  methods: {
    getHoursArray() {
      return this.weekDate.map((_, dayIndex) => {
        let dayValue = 0;

        // 检查24个小时中哪些被选中了
        for (let hour = 1; hour <= 24; hour++) {
          if (this.selectCells[`${dayIndex}_${hour}`]) {
            // 注意：代码中hour是1-24，对应bit位的0-23位
            dayValue += Math.pow(2, hour - 1);
          }
        }

        return dayValue;
      });
    },

    // 修改getData方法，返回hours数组格式
    getDatas() {
      return {
        hours: this.getHoursArray(),
        // 保留原始格式数据（如果需要）
        rawData: this.selectDate
      };
    },
    getsumtime() {
      const timeData = this.getDatas();
      console.log(timeData.hours);
    },
    clone(obj) {
      return JSON.parse(JSON.stringify(obj));
    },

    init(data) {
      this.selectCells = data && data instanceof Object ? data : {};
      this.getSelectDate();
    },

    handleMouseDown(column, row, e) {
      this.moveStartEvent = true;
      this.moveStartColumn = column;
      this.moveStarRow = row;
      this.moveStartX = e.layerX;
      this.moveStartY = e.layerY;
    },

    handleMouseUp(column, row) {
      if (this.moveStartEvent) {
        this.moveStartEvent = false;
        const checked = !this.selectCells[`${column}_${row}`];

        if (row - this.moveStarRow > -1 && column - this.moveStartColumn > -1) {
          const newSelectCells = { ...this.selectCells };

          for (let i = this.moveStartColumn; i <= column; i++) {
            for (let j = this.moveStarRow; j <= row && j <= 24; j++) {
              const key = `${i}_${j}`;
              if (checked) {
                newSelectCells[key] = true;
              } else {
                delete newSelectCells[key];
              }
            }
          }

          this.selectCells = newSelectCells;
          this.$forceUpdate();
          this.getSelectDate();
        }
      }
      this.moveStartDay = 0;
      this.moveStarTime = 0;
    },

    handleMouseMove(e) {
      if (this.moveStartEvent) {
        const dom = this.$el.querySelector('#box');
        const X = e.layerX - this.moveStartX;
        const Y = e.layerY - this.moveStartY;
        if (X >= 0 && Y >= 0) {
          dom.style.left = `${this.moveStartX}px`;
          dom.style.top = `${this.moveStartY}px`;
          dom.style.width = `${X}px`;
          dom.style.height = `${Y}px`;
        }
      }
    },

    getSelectDate() {
      const arr = this.weekDate.map((item, index) => {
        const dayData = {
          label: item,
          data: []
        };

        // 遍历24小时时间段
        for (let i = 1; i <= 24; i++) {
          if (this.selectCells[`${index}_${i}`]) {
            const startHour = (i - 1).toString().padStart(2, '0');
            const endHour = i.toString().padStart(2, '0');
            dayData.data.push([`${startHour}:00`, `${endHour}:00`]);
          }
        }

        // 合并相邻时间段
        const mergedData = [];
        let currentRange = null;

        dayData.data.forEach(time => {
          if (!currentRange) {
            currentRange = [...time];
          } else if (currentRange[1] === time[0]) {
            currentRange[1] = time[1];
          } else {
            mergedData.push(currentRange);
            currentRange = [...time];
          }
        });

        if (currentRange) mergedData.push(currentRange);
        dayData.data = mergedData;

        return dayData;
      });

      this.selectDate = arr;
    },

    handleClear() {
      this.selectCells = {};
      this.getSelectDate();
      this.$forceUpdate();
    },

    getData() {
      return this.selectDate;
    }
  }
}
</script>
   
<style scoped>
.timeRange {
  user-select: none;
  position: relative;
  padding: 10px 0;

  .calendar {
    display: inline-block;
  }

  table {
    width: 100%;
    border-radius: 4px;
    border-spacing: 0;
    table-layout: fixed;
    border-collapse: collapse;

    thead {

      th,
      td {
        height: 30px;
      }

      th {
        padding: 5px 0;

      }

      .weekRow {
        width: 100px;
        min-width: 100px;
        padding: 20px 0
      }
    }

    td,
    th {
      outline: 0;
      border: 1px solid #E3E3E3;
      font-size: 12px;
      text-align: center;
      min-width: 11px;
      line-height: 1.6em;
      min-width: 24px;
    }

    tbody {
      position: relative;
      overflow: hidden;

      td {
        height: 20px !important;
      }
    }

    td.active {
      background: hsl(207, 97%, 49%);
    }
  }

  .table-core {
    line-height: 2.4em;
    border: 1px solid #E3E3E3;
    border-top: 0;
    overflow: hidden;
    padding: 10px;

    .clearfix {
      color: #8A8A8A;
      text-align: left;
      height: 22px;
      line-height: 22px;
      margin: 8px 0;
      display: flex;
      font-size: 12px;

      .clearBtn {
        cursor: pointer;
        color: #5775F9;
        font-size: 14px;
        margin-left: auto;
      }
    }

    ul {
      margin: 0;
      padding: 0;
      list-style: none;

      li {
        display: flex;
        align-items: center;
        line-height: 24px;
        margin-bottom: 8px;
        padding: 4px 0;

        label {
          display: inline-block;
          min-width: 60px;
          color: #475569;
          text-align: left;
          font-weight: 500;
          font-size: 13px;
        }

        span {
          font-size: 13px;
          background-color: #f1f5f9;
          padding: 2px 8px;
          border-radius: 4px;
          margin-right: 6px;
          color: #334155;

          &::after {
            display: none;
          }
        }
      }
    }

  }

  #box {
    background: rgba(241, 1, 85, 0.4);
    pointer-events: none;
    position: absolute;
    top: 0;
    left: 0;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/login/selectime.vue